module.exports = __webpack_public_path__ + "static/src/content/images/processed/thumb/Dunkirk_.74a2722.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/processed/thumb/Dunkirk_.jpg
// module id = gaCm
// module chunks = 0